import axios from 'axios';
import { touchWebClient } from 'tradera/utils/http';
import { axiosConfigs } from 'tradera/utils/api';
import type {
    CampaignRequest,
    CampaignResponse,
    CampaignValidationResult,
} from './types';

const getCampaignCode = async (
    campaignCode: string,
    categoryId: string,
    brandAttributeValues: string[],
) => {
    const requestData = {
        code: campaignCode,
        selectedCategories: categoryId ? [categoryId] : [],
        selectedBrandAttributes: brandAttributeValues,
    };
    try {
        const response = await touchWebClient.post<
            CampaignResponse,
            CampaignRequest
        >('/selling/api/campaign', requestData, {
            cancelTokenId: 'SELLING_CAMPAIGN_CODE',
            ...axiosConfigs.authenticated,
        });
        return response.data;
    } catch (error) {
        if (axios.isCancel(error)) {
            throw 'aborted';
        }
        throw 'Could not get the campaignCode';
    }
};

const validate = async (
    campaignCode: string,
    categoryId: string,
    brandAttributeValues: string[],
): Promise<CampaignValidationResult> => {
    try {
        const data = await getCampaignCode(
            campaignCode,
            categoryId,
            brandAttributeValues,
        );

        const result: CampaignValidationResult = {
            campaignCodeValid: data.validation.isValid,
            validationDisplayMessage: data.validation.message,
            hasEnded: data.validation.hasEnded,
        };
        // KATS: this mapping serves no real purpose other adding another layer of abstraction, should probably be removed
        // when the campaign code is refactored to TS so that it's simple to rename the fields and catch any errors in code-time
        // instead of run-time.
        if (data.campaign) {
            result.campaignCode = data.campaign.code;
            result.campaignCodeId = data.campaign.id;
            result.campaignCodeMessage = data.campaign.description;
            result.isCustomLengthFeeFree = data.campaign.isCustomLengthFeeFree;
            result.isUnsoldFeeFree = data.campaign.isUnsoldFeeFree;
            result.provisionFactor = data.campaign.provisionFactor;
            result.discountFactor = data.campaign.discountFactor;
            result.maxFeeCap = data.campaign.maxFeeCap;
            result.bannerMobileImageUrl = data.campaign.bannerMobileImageUrl;
            result.bannerTabletImageUrl = data.campaign.bannerTabletImageUrl;
            result.bannerDesktopImageUrl = data.campaign.bannerDesktopImageUrl;
        }
        return result;
    } catch (reason) {
        if (reason === 'aborted') {
            return {
                campaignCodeValid: false,
                validationDisplayMessage: 'Valideringen avbröts.',
            };
        }

        return {
            campaignCodeValid: false,
            validationDisplayMessage: 'Kunde inte validera kampanjkoden.',
        };
    }
};

export default { validate };
